import { createContext, useContext, useMemo, useState } from "react";




export interface ILogin {
  userId: number;
  userName: string;
  token: string;

}

interface AuthContextType {
  loggedin: boolean;
  userId: number | null;
  login: (data: ILogin) => void;
  logout: () => void;
  userName: string;
  loginObj: ILogin | null;

}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [loginObj, setLoginObj] = useState<ILogin | null>(() => {
    const auth = sessionStorage.getItem("loginData");
    return auth ? JSON.parse(auth) : null;
  });
  const loggedin = !!loginObj;

  const login = (data: ILogin) => {
    const enriched: ILogin = {
      ...data,
    };
    sessionStorage.setItem("loginData", JSON.stringify(enriched));
    setLoginObj(enriched);
  };

  const logout = () => {
    sessionStorage.removeItem("loginData");
    sessionStorage.removeItem("activePortal");
    setLoginObj(null);
  };

  
  const userName = loginObj?.userName ?? "";
  const userId = loginObj?.userId ?? null;

  return (
    <AuthContext.Provider
      value={{
        userId,
        loggedin,
        login,
        logout,
        userName,
        loginObj,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};